(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/pages/frejaeid/components/frejaeid-start.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/pages/frejaeid/components/frejaeid-start.js');

'use strict';

const {
  ReactButton: Button
} = svs.ui;
const Bank = svs.ui.ReactBank;
const {
  route
} = svs.playerLoginReact.constants;
const {
  useUrlHelper,
  SelectEidMenu
} = svs.playerLoginReact.sharedComponents;

const FrejaeIdStart = _ref => {
  let {
    isLogin = true
  } = _ref;
  const history = ReactRouterDOM.useHistory();
  const {
    navigateToCancelUrl
  } = useUrlHelper();
  const isStandardMobile = ReactRedux.useSelector(state => state.playerloginreact.isStandardMobile);
  const onFrejaeIdThisDeviceClick = () => {
    if (isLogin) {
      history.push(route.LOGIN_FREJAEID_POLL_APP_ROUTE);
    } else {
      history.push(route.REGISTRATE_FREJAEID_POLL_APP_ROUTE);
    }
  };
  const onnavigateToCancelUrl = () => {
    navigateToCancelUrl();
  };

  React.useLayoutEffect(() => {
    if (!isStandardMobile) {
      if (isLogin) {
        history.push(route.LOGIN_FREJAEID_POLL_QR_ROUTE);
      } else {
        history.push(route.REGISTRATE_FREJAEID_POLL_QR_ROUTE);
      }
    }
  }, [history, isLogin, isStandardMobile]);
  return React.createElement(React.Fragment, null, isStandardMobile && React.createElement(React.Fragment, null, React.createElement(SelectEidMenu, {
    isLogin: isLogin
  }), React.createElement(Button, {
    block: true,
    iconPosition: "left",
    inverted: true,
    onClick: onFrejaeIdThisDeviceClick,
    size: 300
  }, React.createElement(Bank, {
    className: "align-left animate animate-show animate-time-short",
    name: "freja-eid-vertical-neg",
    size: 24
  }), React.createElement("span", {
    className: "animate animate-show animate-time-short"
  }, isLogin ? 'Logga in' : 'Bli kund')), React.createElement("div", {
    className: "margin-xs-top-1"
  }, React.createElement(Button, {
    block: true,
    onClick: onnavigateToCancelUrl,
    size: 300,
    transparent: true
  }, "Avbryt"))), !isStandardMobile && null);
};
svs.playerLoginReact.frejaeid.components.FrejaeIdStart = FrejaeIdStart;

 })(window);